import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { triggerExpandReviewEvent } from '../utilities/analytics';
import Truncate from './Truncate';

import '../global-sass/main.scss';

const ReadMore = (props) => {
	const [expanded, setExpanded] = useState(false);
	const [truncated, setTruncate] = useState(false);

	const handleTruncate = (truncat) => {
		if (truncated !== truncat) {
			setTruncate(truncat);
		}
	};

	const toggleLines = (
		event,
		element,
		elementCTA,
		result,
		windowId,
		widgetName
	) => {
		event.preventDefault();
		triggerExpandReviewEvent(
			element,
			elementCTA,
			result,
			windowId,
			widgetName
		);
		setExpanded(!expanded);
	};

	const { children, more, less, lines, windowId, widgetName, labels } = props;
	const readMoreLinkClasses = ['read-more-link', 'text-link', 'd-block'];

	return (
		<div className="review-body">
			<Truncate
				lines={!expanded && lines}
				ellipsis={
					<span>
						&hellip;{' '}
						<button
							className={readMoreLinkClasses.join(' ')}
							onClick={(event) => {
								toggleLines(
									event,
									'Read more link',
									more,
									'Review expanded',
									windowId,
									widgetName
								);
							}}
							type="button"
						>
							{labels.get(more)}
						</button>
					</span>
				}
				onTruncate={handleTruncate}
			>
				{children}
			</Truncate>
			{!truncated && expanded && (
				<span>
					{' '}
					<button
						className={readMoreLinkClasses.join(' ')}
						onClick={(event) => {
							toggleLines(
								event,
								'Read less link',
								less,
								'Review collapsed',
								windowId,
								widgetName
							);
						}}
						type="button"
					>
						{labels.get(less)}
					</button>
				</span>
			)}
		</div>
	);
};
ReadMore.defaultProps = {
	lines: 2,
	more: 'READ_MORE',
	less: 'SHOW_LESS'
};

ReadMore.propTypes = {
	children: PropTypes.node.isRequired,
	more: PropTypes.string,
	less: PropTypes.string,
	lines: PropTypes.number,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired
};

export default ReadMore;
